export default {
  all: 'Todos',
  app_disabled: 'Desculpe mas a aplicação não é disponiível no momento',
  back_to_list: 'Voltar à lista',
  catalogue_image: 'Imagem do encarte',
  catalogues: 'Encartes',
  catalogues_in_area: 'Encartes na sua área',
  catalogues_loading: 'Carregando encartes próximos a você',
  catalogues_near_you: 'Ofertas nas proximidades',
  catalogues_not_found:
    'Não existem encartes ativos próximo a você. Insira um novo endereço ou tente novamente mais tarde',
  close_catalogues: 'Fechar a folha de encartes',
  close_products: 'Fechar a folha de produtos',
  close_stores: 'Fechar a folha de lojas',
  closed: 'Fechado',
  characteristics: 'Características',
  description_missing: 'Nenhuma descrição disponível',
  days_of_week: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  expired: 'Venceu',
  expires: 'Vence',
  geolocation_error: 'Atenção: a localização não é correta',
  geolocation_loading: 'Estamos configurando a sua posição',
  more_info: 'Maiores informações',
  next: 'Próximo',
  of: 'De',
  open: 'Aberto',
  open_24_hours: 'Aberto 24h',
  other_stores: 'Ofertas disponíveis nas seguintes lojas:',
  page: 'Página',
  previous: 'Anterior',
  price: 'Preço',
  products: 'Produtos',
  products_list: 'Lista de produtos',
  read_all: 'Leia tudo',
  sale: 'Desconto',
  search_placeholder: 'O que você estaá procurando',
  stores: 'Lojas',
  understand: 'Entendi',
  usergeolocation_label:
    'Insira o seu endereço para encontrar as melhores ofertas das lojas próximas a você',
  directionVertical: 'Scroll vertical',
  directionHorizontal: 'Scroll horizontal',
  share: 'Compartilhe-os',
  share_with_friends: 'Compartilhe com os seus amigos',
  copy_link: 'cópia de link',
  sms: 'SMS',
  email: 'email',
  stores_within: 'Lojas dentro de {maxDistance}',
  invalid_offers_disclaimer:
    'As ofertas neste folheto não são válidas em lojas próximas a você, abra outro folheto ou localize em uma área diferente.',
  available_options: 'Disponível em {numOptions} opções:',
  flyer_unavailable_error:
    'Não foi possível abrir este folheto. Verifique o link ou tente novamente mais tarde.',
};
